import { Add } from "@mui/icons-material";
import { FormControlLabel, MenuItem, Select, TextField } from "@mui/material";
import CustomerDialog from "components/CustomerDialog";
import PaperButton from "components/buttons/PaperButton";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { currency } from "lib/formatter";
import { getUsers } from "models/usersModel";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { openLoading } from "store/reducers/tools";
import CustomersTable from "./forms/CustomersTable";

const spentOptions = [
  { label: "All", value: "0" },
  {
    label: `${currency.format(1000)} to ${currency.format(10)}`,
    value: "1",
    start: 10,
    end: 1000,
  },
];

const perPage = 50;

export default function CustomersComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState([]);
  const [spent, setSpent] = useState("0");
  const [searchWord, setSearchWord] = useState("");
  const [open, setOpen] = useState(false);
  const [phoneCode, setPhoneCode] = useState("64");
  const [totalPage, setTotalPage] = useState(1);
  const [filter, setFilter] = useState({});

  const loadData = () => {
    openLoading(true);
    getUsers({
      data: {
        limit: perPage,
        role: ["0"],
        ...filter,
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        setData(res?.data);
        setTotalPage(res?.pageCount ?? 1);
      },
    });
  };

  const handleAdd = () => {
    setOpen(true);
  };

  const handleChangePage = (v) => {
    setFilter((prev) => ({ ...(prev ?? {}), ...(v ?? {}) }));
  };

  const handleSearchWord = (e) => {
    setSearchWord(e.target.value.trim().replace(/[^A-Za-z0-9@. ]/g, ""));
  };

  useEffect(() => {
    if (searchWord || spent) {
      let filter = {
        searchWord,
        start_spent: spentOptions?.[spent]?.start ?? 0,
        end_spent: spentOptions?.[spent]?.end ?? 0,
      };

      setFilter((prev) => ({
        sortKey: prev?.sortKey ?? {},
        page: 1,
        ...(filter ?? {}),
      }));
    }
    // eslint-disable-next-line
  }, [searchWord, spent]);

  useEffect(() => {
    if (filter?.sortKey) loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <div>
      <div className="flex justify-between mb-4">
        <div className="flex">
          <TextField
            defaultValue={searchWord}
            onBlur={handleSearchWord}
            onKeyDown={(e) => {
              if (e.key === "Enter") handleSearchWord(e);
            }}
            id="outlined-basic"
            label="Search"
            variant="outlined"
            size="small"
            placeholder="Search Customers"
            style={{ width: 250 }}
            inputProps={{ style: { background: "#fff" } }}
          />
          <FormControlLabel
            value="start"
            label={
              <CustomText
                className="whitespace-nowrap"
                variant="body2"
                color="secondary"
                bold={true}
              >
                Spent :&nbsp;
              </CustomText>
            }
            labelPlacement="start"
            control={
              <Select
                size="small"
                sx={{ background: "#fff", width: 160 }}
                value={spent}
                onChange={(e) => setSpent(e.target.value)}
              >
                {spentOptions?.map((item) => (
                  <MenuItem value={item?.value} key={item?.value}>
                    {item?.label ?? ""}
                  </MenuItem>
                ))}
              </Select>
            }
          />
        </div>
        <PaperButton
          onClick={handleAdd}
          icon={<Add className="text-light-gray" />}
        >
          Add New User
        </PaperButton>
      </div>
      <CustomersTable
        data={data}
        onLoadData={handleChangePage}
        totalPage={totalPage}
        page={filter?.page}
      />
      <CustomerDialog
        data={{ phone_code: phoneCode }}
        open={open}
        actionType="add"
        title="Add New Customer"
        onChangePhoneCode={(v) => setPhoneCode(v)}
        onClose={() => setOpen(false)}
        onEditUser={(newUser) => {
          loadData();
          setOpen(false);
        }}
      />
    </div>
  );
}
